import { createClient } from "@supabase/supabase-js";

/**
 * Supabase client.
 *
 * The publishable key (sb_publishable_...) replaces the old anon key. Same
 * low privileges, so row level security behaves identically and sign-in is
 * unchanged. Legacy anon keys still work as a fallback.
 *
 * Both are safe to ship in the browser — the RLS policies in db/ are what
 * protect the data. A secret key (sb_secret_...) bypasses all of them and
 * must never appear in a VITE_ variable.
 *
 * Deliberately does NOT throw on import. A missing variable used to blank
 * the whole page with only a console error; now it surfaces as a readable
 * screen instead.
 */

const url = import.meta.env.VITE_SUPABASE_URL;
const key =
  import.meta.env.VITE_SUPABASE_PUBLISHABLE_KEY ||
  import.meta.env.VITE_SUPABASE_ANON_KEY;

export const configError =
  !url ? "VITE_SUPABASE_URL is missing."
  : !key ? "VITE_SUPABASE_PUBLISHABLE_KEY is missing."
  : !/^https:\/\/.+\.supabase\.co/.test(url) ? `VITE_SUPABASE_URL doesn't look right: ${url}`
  : key.startsWith("sb_secret_") ? "That's a secret key. It bypasses row level security and must never be used in the browser."
  : null;

export const supabase = configError ? null : createClient(url, key, {
  auth: { persistSession: true, autoRefreshToken: true },
});
